import React, { useContext, useMemo, useState } from 'react';
import CardBox from '../../../CardBox';
import { Button, Empty } from '@maxtropy/components';
import { DoubleRightOutlined } from '@ant-design/icons';
import styles from './index.module.scss';
import ReactEcharts from 'echarts-for-react';
import { getChartOption } from './chart';
import { useRequest } from 'ahooks';
import { apiV2MicrogridOverviewGetOperatingPowerCurvePost } from '@maxtropy/intelligent-dispath-apis-v2';
import { ShareDataContext } from '@/pages/IndustrialGreenMicBigScreen';
import { Spin } from 'antd';
import PowerPredictionModal from './PowerPredictionModal';

const OperatingPowerCurve = () => {
  const { microgridId } = useContext(ShareDataContext);
  const [predictModalOpen, setPredictModalOpen] = useState<boolean>(false); // 查看预测弹窗

  // 运行曲线
  const { data: chartsData, loading: chartsDataLoading } = useRequest(
    () => {
      return apiV2MicrogridOverviewGetOperatingPowerCurvePost({
        configId: microgridId,
      });
    },
    {
      ready: !!microgridId,
      refreshDeps: [microgridId],
      pollingInterval: 1000 * 60 * 15,
    }
  );

  // 图表
  const chartOption = useMemo(() => getChartOption(chartsData), [chartsData]);

  // 判断是否都为空，如果都为空则显示empty
  const isShowEmpty = useMemo(() => {
    if (chartsData?.list?.length) {
      return false;
    }
    return true;
  }, [chartsData]);

  return (
    <CardBox
      title="运行功率曲线"
      extraContent={
        <Button
          type="link"
          style={{ padding: '0' }}
          onClick={() => {
            setPredictModalOpen(true);
          }}
        >
          功率预测
          <DoubleRightOutlined className={styles.translationStyles} />
        </Button>
      }
    >
      {chartsDataLoading ? (
        <Spin spinning={true} />
      ) : isShowEmpty ? (
        <Empty className={styles.empty_box} />
      ) : (
        <ReactEcharts style={{ height: '100%' }} option={chartOption} notMerge lazyUpdate={false} />
      )}
      <PowerPredictionModal
        visible={predictModalOpen}
        onCancel={() => {
          setPredictModalOpen(false);
        }}
      />
    </CardBox>
  );
};

export default OperatingPowerCurve;
